import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { teamApi, type Team } from '../../api/teams';

export function TeamsPage() {
  const [items, setItems] = useState<Team[]>([]);
  const [q, setQ] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      setItems(await teamApi.list(q ? { q } : undefined));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load teams');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  return (
    <div className="mx-auto max-w-5xl p-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Teams</h1>
          <p className="mt-1 text-sm text-slate-600">Collaborative groups within your tenant.</p>
        </div>
        <Link to="/users" className="text-sm text-slate-600 hover:underline">← Users</Link>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); void load(); }} className="mt-6 flex gap-3">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search teams…" className="flex-1 rounded-lg border px-3 py-2" />
        <button type="submit" className="rounded-lg border px-4 py-2 text-sm">Search</button>
      </form>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {loading ? <p className="mt-6">Loading…</p> : (
        <ul className="mt-6 space-y-3">
          {items.map((t) => (
            <li key={t.id} className="rounded-xl border bg-white p-4">
              <Link to={`/teams/${t.id}`} className="font-medium hover:underline">{t.name}</Link>
              <p className="text-sm text-slate-500">{t.slug}</p>
              {t.description && <p className="mt-1 text-sm text-slate-600">{t.description}</p>}
            </li>
          ))}
          {items.length === 0 && <p className="text-slate-500">No teams found.</p>}
        </ul>
      )}
    </div>
  );
}
